import type {
	BaseMetricDataWithStartAndStop,
	PerformanceEventConfig,
	ShareableGlobalConfig,
} from '../../types';

export const eventPopulation = (
	_config: PerformanceEventConfig,
	_data: BaseMetricDataWithStartAndStop,
	globalConfig: ShareableGlobalConfig,
) => {
	if (!globalConfig.population) {
		return {};
	}
	return {
		'event:population': `${globalConfig.population}`,
	};
};
